


















import { Vue } from "../../constants/constants";
import { staticContent } from "../../localisation/detect-lang";
import {
  KEYS,
  getRemoteConfigAsBoolean,
  ensureRemoteConfigInitialize
} from "../../firebase";


export default Vue.component("landing-install-banner", {

  data() {
    return {
      title: '',
      body: '',
      isOpened: true,
      staticContent,
    };
  },

  mounted() {
    this.openBanner();
  },

  methods: {
    pushInstallAppEvent() {
      this.$root.pushInstallAppEvent('landing banner');
    },
    openBanner() {
      ensureRemoteConfigInitialize().then(() => {
        const isOpened = getRemoteConfigAsBoolean(KEYS.Install_Incentives.Show_Landing_Banner);
        if (isOpened) {
          document.querySelector('.landing-page').classList.add('landing-page--padded');
        }
        this.isOpened = isOpened;
        this.title = this.getTitle();
        this.body = this.getBody();
      });

    },
    getTitle() {
      return this.$root.getAppIncentiveText(KEYS.Install_Incentives.Landing_Banner, KEYS.Install_Incentives.Title)
    },
    getBody() {
      return this.$root.getAppIncentiveText(KEYS.Install_Incentives.Landing_Banner, KEYS.Install_Incentives.Body)
    },
    closeBanner() {
      this.isOpened = false;
      document.querySelector('.landing-page').classList.remove('landing-page--padded');
    }
  },
});
